import * as React from 'react';
export const twintSvg = React.forwardRef(function twintSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.737 7.919s-.433-.64-.709-1.078c-.305-.477.04-1.183.71-1.183.679 0 1.014.706.709 1.183-.276.448-.71 1.078-.71 1.078Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.74 12.244a.72.72 0 0 0 .33-.565V4.321a.733.733 0 0 0-.33-.565L8.33.082A.648.648 0 0 0 8 0c-.12 0-.24.027-.33.082L1.26 3.756a.717.717 0 0 0-.33.565v7.358c0 .208.15.456.33.565l6.41 3.674c.09.055.21.082.33.082a.64.64 0 0 0 .329-.082l6.412-3.674Zm-3.762-4.382-1.645 2.347-.847-1.26.975-1.412c.177-.248.571-.944.118-1.889-.364-.763-1.152-1.135-1.842-1.135s-1.448.343-1.842 1.135a1.784 1.784 0 0 0 .109 1.86l.995 1.422.738 1.03 1.104 1.632.005.007c.033.042.206.26.487.26.26 0 .429-.2.485-.267l.017-.019 2.59-3.711h-1.447Zm-4.836 2.27L4.517 7.928s-.434-.639-.71-1.078c-.305-.477.04-1.183.71-1.183.088 0 .167.01.236.029l.571-1.011a2.217 2.217 0 0 0-.807-.163c-.69 0-1.448.344-1.842 1.136a1.784 1.784 0 0 0 .108 1.86l2.837 4.074c.02.038.207.296.502.296.289 0 .454-.222.496-.278l.006-.008.857-1.26-.738-1.05-.601.84Z',
      clipRule: 'evenodd',
    }),
  );
});
twintSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var twint = {
  category: 'paymentmethod',
  colorable: true,
  name: 'twint',
  svg: twintSvg,
};
